import React from 'react';
import { XIcon, GiftIcon, ShoppingCartIcon } from 'lucide-react';
interface ExtraBonusModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function ExtraBonusModal({
  isOpen,
  onClose
}: ExtraBonusModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50" data-id="element-127">
      <div className="bg-white rounded-xl sm:rounded-2xl max-w-3xl w-full max-h-[90vh] overflow-hidden" data-id="element-128">
        <div className="flex items-center justify-between p-4 sm:p-6 border-b bg-gradient-to-r from-purple-600 to-pink-600" data-id="element-129">
          <div className="flex items-center gap-2 sm:gap-3" data-id="element-130">
            <GiftIcon className="w-6 h-6 sm:w-8 sm:h-8 text-white" data-id="element-131" />
            <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-white" data-id="element-132">
              ¡Super Regalo Extra!
            </h2>
          </div>
          <button onClick={onClose} className="text-white hover:text-gray-200 transition p-2 rounded-lg hover:bg-white/10" aria-label="Cerrar modal" data-id="element-133">
            <XIcon className="w-6 h-6" data-id="element-134" />
          </button>
        </div>
        <div className="p-4 sm:p-6 overflow-y-auto max-h-[calc(90vh-80px)]" data-id="element-135">
          <div className="text-center mb-6" data-id="element-136">
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2" data-id="element-137">
              🎉 Llévate estos 3 ebooks extra como regalo 🎉
            </h3>
            <p className="text-lg sm:text-xl text-purple-600 font-semibold" data-id="element-138">
              Total te llevas 7 libros
            </p>
          </div>
          <div className="rounded-xl overflow-hidden shadow-2xl mb-6" data-id="element-139">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/q3cm2PjD1287e6bpERNj8d/bonos_extra.png" alt="3 Ebooks Extra de Regalo" className="w-full h-auto" data-id="element-140" />
          </div>
          <div className="bg-gradient-to-br from-purple-50 to-pink-50 p-5 sm:p-6 rounded-xl border-2 border-purple-200" data-id="element-141">
            <h4 className="font-bold text-lg sm:text-xl mb-4 text-center text-purple-800 leading-tight" data-id="element-142">
              🎄 Regalo de Lanzamiento de Nuestra Campaña Navideña 🎄
              <br data-id="element-143" />
              Incluye 3 Bonos Extra:
            </h4>
            <ul className="space-y-3 sm:space-y-4 text-gray-700" data-id="element-144">
              <li className="flex items-start gap-3" data-id="element-145">
                <span className="text-2xl flex-shrink-0" data-id="element-146">📖</span>
                <div data-id="element-147">
                  <strong className="text-base sm:text-lg" data-id="element-148">
                    Kit Anti-Sobras Navidad & Año Nuevo
                  </strong>
                  <p className="text-sm sm:text-base" data-id="element-149">
                    Recetas para aprovechar las sobras de las fiestas
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3" data-id="element-150">
                <span className="text-2xl flex-shrink-0" data-id="element-151">🎄</span>
                <div data-id="element-152">
                  <strong className="text-base sm:text-lg" data-id="element-153">
                    Menús Festivos Express de Navidad & Año Nuevo
                  </strong>
                  <p className="text-sm sm:text-base" data-id="element-154">
                    Menús completos para las celebraciones
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3" data-id="element-155">
                <span className="text-2xl flex-shrink-0" data-id="element-156">💰</span>
                <div data-id="element-157">
                  <strong className="text-base sm:text-lg" data-id="element-158">
                    Calculadora de Fiesta Navideña
                  </strong>
                  <p className="text-sm sm:text-base" data-id="element-159">
                    Guía para economizar y ahorrar en las fiestas
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div className="text-center mt-6" data-id="element-160">
            <p className="text-lg font-semibold text-gray-800 mb-2" data-id="element-161">
              ¡Todo incluido automáticamente con tu compra!
            </p>
            <p className="text-sm text-gray-600 mb-4" data-id="element-162">
              4 libros principales + 3 bonos extra = 7 libros en total
            </p>
            <a href="https://mikioscodigital.com/cart/51606060794137:1?checkout" target="_blank" rel="noopener noreferrer" className="group relative inline-flex items-center justify-center gap-3 px-8 py-4 sm:px-10 sm:py-5 rounded-full bg-gradient-to-br from-amber-300 via-amber-500 to-amber-600 text-gray-900 font-bold text-lg sm:text-xl tracking-wide shadow-[0_0_20px_rgba(245,158,11,0.5)] hover:shadow-[0_0_40px_rgba(245,158,11,0.8)] hover:scale-105 hover:-translate-y-1 transition-all duration-300 mx-auto w-full sm:w-auto overflow-hidden border-2 border-amber-200/50" data-id="element-163">
              {/* 3D Shine Overlay */}
              <div className="absolute inset-0 bg-gradient-to-br from-white/40 via-white/10 to-transparent opacity-100 pointer-events-none rounded-full" data-id="element-164"></div>

              {/* Animated Glow Pulse */}
              <div className="absolute inset-0 rounded-full bg-amber-400/30 blur-xl animate-pulse" data-id="element-165"></div>

              <ShoppingCartIcon className="relative z-10 w-6 h-6 sm:w-7 sm:h-7 drop-shadow-md" data-id="element-166" />
              <span className="relative z-10 drop-shadow-md uppercase" data-id="element-167">
                QUIERO MI PACK DE 15 MINUTOS AHORA!!!
              </span>
            </a>
            <p className="text-sm text-gray-600 mt-3" data-id="element-168">
              Valor $250, Hoy $9.95 USD
            </p>
          </div>
        </div>
      </div>
    </div>;
}